import clsx from 'clsx';

interface InputProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {
  className?: string;
  innerRef?: React.MutableRefObject<HTMLInputElement>;
}

const Input = ({
  type = 'text',
  className,
  value,
  name,
  innerRef,
  ...props
}: InputProps) => (
  <input
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    ref={innerRef}
    type={type}
    name={name}
    value={value}
    className={clsx(
      'border border-2 border-gray-200 focus:outline-none py-1 w-full',
      className
    )}
  />
);

export default Input;
